
import { PlusIcon, PencilIcon, CalendarIcon } from "@heroicons/vue/24/solid";
import { format, subDays, getISODay, parseISO } from "date-fns";
import { defineComponent, PropType } from "vue";
import DailyReportRepository from "@/repositories/DailyReportRepository";
import CopySectionData from "@/views/daily_report/components/SectionCopyData.vue";

export default defineComponent({
  props: {
    note: {
      type: String as PropType<string>,
      required: true,
    },
    editMode: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    highlightSection: {
      type: String as PropType<string>,
      required: true,
    },
    approved: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    validationError: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
  },
  emits: ["addHighlight", "activeEditMode", "updateSectionData"],
  components: {
    PlusIcon,
    PencilIcon,
    CalendarIcon,
    CopySectionData,
  },
  data() {
    return {
      copyDataOpen: false,
      date: this.$route.params.date as string,
      searchDate: "",
      error: false,
      errorMessage: "",
    };
  },
  computed: {
    yesterday() {
      const dateObj = parseISO(this.date);
      if (getISODay(dateObj) === 1) {
        return format(subDays(dateObj, 2), "yyyy-MM-dd");
      }
      return format(subDays(dateObj, 1), "yyyy-MM-dd");
    },
  },
  methods: {
    activeEditMode() {
      this.$emit("activeEditMode");
      this.$emit("addHighlight");
    },

    copySectionData(date: string) {
      this.error = false;
      this.errorMessage = "";
      const { customer_name, site_id } = this.$route.params;
      return DailyReportRepository.getSectionValueCopy(
        "notes",
        customer_name as string,
        site_id as string,
        date,
      )
        .then((response) => {
          if (response.data === "") {
            this.showToast("warning", this.$t("err.saved_values"));
          }
          this.$emit("updateSectionData", response.data);
        })
        .catch(() => {
          this.showToast("warning", this.$t("err.saved_values"));
        })
        .finally(() => this.$emit("activeEditMode"));
    },
  },
});
